import { render, staticRenderFns } from "./AlertWidget.vue?vue&type=template&id=63c3d056&scoped=true&"
import script from "./AlertWidget.vue?vue&type=script&lang=js&"
export * from "./AlertWidget.vue?vue&type=script&lang=js&"
import style0 from "./AlertWidget.vue?vue&type=style&index=0&id=63c3d056&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c3d056",
  null
  
)

export default component.exports